// extracted by mini-css-extract-plugin
export var avatar = "_q2-3";
export var avatarContainer = "_q2-2";
export var avatarSpacer = "_q2-5";
export var avatarSpacerContainer = "_q2-4";
export var avatarStackContainer = "_q2-1";
export var bubble = "_q2-0";
export var remainderBubble = "_q2-6";